import React from 'react';
import { Upload, message, Button } from 'antd';
import ArrowUpIcon from "../../../assets/images/icons/arrow_up.svg";
import { CloseRounded } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { toggleTour } from '../../../reducers/tourSlice';
import * as XLSX from 'xlsx';

const { Dragger } = Upload;

const UploadMedia = ({ handleFileSelect, fileList, handelClick, disabled }) => {
    const dispatch = useDispatch();
    const beforeUpload = (file) => {
        // Define the allowed MIME type for .xlsx files
        const allowedMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

        // Check if the file MIME type matches the allowed .xlsx MIME type
        if (file.type !== allowedMimeType) {
            message.error("Invalid File format. File should be in .xlsx format");
            return Upload.LIST_IGNORE;
        }

        // Validate file size (should be smaller than 150MB)
        if ((file.size / 1024 / 1024) > 150) {
            message.error('File must be smaller than 150MB');
            return Upload.LIST_IGNORE;
        }

        // Check for special characters in file name (allowed characters: letters, numbers, dashes, and ampersands)
        const validFilenameRegex = /^[a-zA-Z0-9\-&_ ]+\.xlsx$/;
        if (!validFilenameRegex.test(file.name)) {
            message.error("File name contains invalid characters.");
            return Upload.LIST_IGNORE;
        }


        // Checking and removing duplicate file
        const isDuplicate = fileList.some(existingFile => existingFile.name === file.name);
        if (isDuplicate) {
            return Upload.LIST_IGNORE;
        }

        // Read the content of the .xlsx file to check the header
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (e) => {
            const data = e.target.result;

            // Check if the file is actually a valid .xlsx file by reading the first few bytes (magic number check)
            const fileBytes = new Uint8Array(data.slice(0, 4));
            const magicNumber = [80, 75, 3, 4]; // This is the magic number for .xlsx (PK\x03\x04)

            // Check if the file starts with the correct magic number for .xlsx files
            const isXlsxFile = fileBytes.every((byte, index) => byte === magicNumber[index]);

            if (!isXlsxFile) {
                message.error('Invalid File format. File should be a valid .xlsx file.');
                handleFileSelect([]); // Reset the file selection if invalid
                return Upload.LIST_IGNORE;
            }

            // Parse the file using XLSX.js to check the headers (only proceed if it's a valid .xlsx file)
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

            // Get the headers (assuming the first row has the headers)
            const headers = XLSX.utils.sheet_to_json(firstSheet, { header: 1 })[0];

            // Check if the header contains 'Policy Number'
            if (!headers.includes('Policy Number')) {
                message.error('Invalid Content. Only "Policy Number" Header is allowed.');
                handleFileSelect([]); // Reset the file selection if invalid
                return Upload.LIST_IGNORE;
            }
        }

        // If all checks pass, proceed with the upload
        return true;
    };

    const handleFileChange = (file) => {
        const data = file.fileList.map(item => item.originFileObj ? item.originFileObj : item)
        handleFileSelect(data);
    };

    const customRequest = ({ file, onSuccess }) => {
        if (file && file.name) {
            onSuccess("ok");
        }
    }

    const onRemove = () => {
        handleFileSelect([]);
    }

    const handleClickOnDragger = () => {
        dispatch(toggleTour({ show: false }));
    }

    return (
        <Dragger className='pcvc-upload'
            fileList={fileList}
            multiple={false}
            beforeUpload={beforeUpload}
            onChange={handleFileChange}
            customRequest={customRequest}
            showUploadList={false}
            maxCount={1}
            onClick={handleClickOnDragger}
            disabled={fileList.length > 0}
        >
            <div className='upload-container'>
                {
                    fileList.length === 0 ?
                        <div className='upload-action'>
                            <div className='title'>Drag and drop here or</div>
                            <button className="btn-outlined">
                                <div className='btn-outlined-content'>
                                    <div className='text'>Upload documents </div>
                                    <img width={29} src={ArrowUpIcon} />
                                </div>
                            </button>
                        </div>
                        :
                        <div className="upload-action" style={{ zIndex: 9999 }} onClick={() => { return; }}>
                            <div className="selectedList">
                                <div className="name">{fileList[0].name}</div>
                                <CloseRounded className="remove" onClick={onRemove} />
                            </div>
                        </div>
                }

            </div>
            <div className="actions">
                <Button type="primary" onClick={handelClick} disabled={disabled}>
                    Submit
            </Button>
            </div>
        </Dragger>

    );
};

export default UploadMedia;
